import { Component, Input } from '@angular/core';
import { PrintService } from '../../../../services/print.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'select-card',
  styleUrls: [
    '../../../wizard/wizard.component.scss',
    '../../print.component.scss',
    './selectCard.component.scss',
  ],
  templateUrl: './selectCard.component.html',
})
export class SelectCardComponent {
  @Input() addCard;
  @Input() cards;

  constructor(
    private printService: PrintService,
    private firebaseService: FirebaseService
  ) {}

  isCardSelected(card) {
    return this.printService.specs.payment_method_id === card.token;
  }

  selectCard(card) {
    this.firebaseService.meta.paymentMethod = card.card_type;
    this.firebaseService.logEvent('checkout_payment_method_select', {
      print_order_id: this.printService.printOrder.id,
      story_id: this.printService.storyId,
      project_id: this.printService.projectId
    });
    this.printService.selectedCard = card;
    this.printService.specs.payment_method_id = card.token;
  }
}
